import { CreatePhoneTenantRequest, UpdatePhoneTenantRequest } from "@shared/zod/schemas/requests/phoneTenant"
import { PhoneTenantResponse } from "@shared/zod/schemas/responses/phoneTenant"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

/** Admin-only: the telephony tenants (Elevate accounts) practices place their callbacks on. */
export const findAll = async (): Promise<PhoneTenantResponse[]> => {
  const resp = await axiosAuth({
    url: "/admin/telephony-tenants",
    method: "get",
  })
  return resp.data
}

export const findOne = async (id: string): Promise<PhoneTenantResponse> => {
  const resp = await axiosAuth({
    url: `/admin/telephony-tenants/${id}`,
    method: "get",
  })
  return resp.data
}

export const create = async (data: CreatePhoneTenantRequest): Promise<PhoneTenantResponse> => {
  const resp = await axiosAuth({
    url: "/admin/telephony-tenants",
    method: "post",
    data,
  })
  return resp.data
}

/** Secrets are write-only: an empty or omitted secret leaves the stored one unchanged. */
export const update = async (id: string, data: UpdatePhoneTenantRequest): Promise<PhoneTenantResponse> => {
  const resp = await axiosAuth({
    url: `/admin/telephony-tenants/${id}`,
    method: "patch",
    data,
  })
  return resp.data
}

export const remove = async (id: string): Promise<void> => {
  await axiosAuth({
    url: `/admin/telephony-tenants/${id}`,
    method: "delete",
  })
}

/** Registers a fresh Elevate webhook subscription for the tenant, retiring the old one. */
export const recreateSubscription = async (id: string): Promise<PhoneTenantResponse> => {
  const resp = await axiosAuth({
    url: `/admin/telephony-tenants/${id}/replace-subscription`,
    method: "post",
  })
  return resp.data
}
